

import React, { useState } from 'react';

import {
    AddContainer, Component4,
    Texts,
    InputTextComponent,
} from './Styles';
import { Formik, Form } from 'formik';
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme';
import * as Yup from 'yup';


const PersonalInfoStep = ({ innerRef, data, setDoctorProfileData }) => {

    const initialValues = {
        profileTitle: data?.profileTitle || '',
        fullName: data?.fullName || '',
        homeAddress: data?.homeAddress || '',
        aboutPersonal: data?.aboutPersonal || '',
        languagesSpoken: Array.isArray(data?.languagesSpoken)
            ? data.languagesSpoken
            : typeof data?.languagesSpoken === 'string'
                ? data.languagesSpoken.split(',').map(s => s.trim())
                : [],
    }
    const Language = [
        { label: 'English', value: 'english' },
        { label: 'Gujarati', value: 'gujarati' },
        { label: 'Hindi', value: 'hindi' },
    ];

    const handleSubmit = (values) => {
        setDoctorProfileData(prev => ({
            ...prev,
            personalInfo: {
                ...values,
                title: 'Dr.',
                displayName: 'titlename',
                profilePic: 'no profile pic',
                profileBannerPic: 'no profileBanner Data',
            }
        }));
    };

    const validationSchema = Yup.object().shape({
        profileTitle: Yup.string().required('Profile Title is required'),
        fullName: Yup.string().required('Full Name is required'),
        aboutPersonal: Yup.string().required('About Personal Field is required'),
        homeAddress: Yup.string().required('Address Field is required'),
        languagesSpoken: Yup.array()
            .min(1, 'At least one language is required')
            .required('Languages Spoken is required'),
    });

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
                innerRef={innerRef}

            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Form>
                        <AddContainer>
                            <Component4>
                                <Texts>Profile Title</Texts>
                                <InputTextComponent
                                    name="profileTitle"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.profileTitle}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.profileTitle && Boolean(errors.profileTitle)}
                                    helperText={touched.profileTitle && errors.profileTitle}
                                />
                            </Component4>

                            <Component4>
                                <Texts>Full Name</Texts>
                                <InputTextComponent
                                    name="fullName"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.fullName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.fullName && Boolean(errors.fullName)}
                                    helperText={touched.fullName && errors.fullName}
                                />
                            </Component4>

                            <Component4>
                                <Texts>Home Address</Texts>
                                <InputTextComponent
                                    name="homeAddress"
                                    placeholder="Enter"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.homeAddress}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.homeAddress && Boolean(errors.homeAddress)}
                                    helperText={touched.homeAddress && errors.homeAddress}

                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            height: '100px',
                                            alignItems: 'flex-start',
                                        },
                                    }}
                                />
                            </Component4>

                            <Component4>
                                <Texts>About Personal</Texts>
                                <InputTextComponent
                                    name="aboutPersonal"
                                    placeholder="Enter"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.aboutPersonal}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.aboutPersonal && Boolean(errors.aboutPersonal)}
                                    helperText={touched.aboutPersonal && errors.aboutPersonal}

                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            height: '100px',
                                            alignItems: 'flex-start',
                                        },
                                    }}
                                />
                            </Component4>

                            <Component4>
                                <Texts>Languages Spoken</Texts>
                                <InputSelect
                                    name="languagesSpoken"
                                    showNone={false}
                                    multiple={true}
                                    options={Language}
                                    value={values.languagesSpoken}
                                    onChange={(value) => setFieldValue('languagesSpoken', value)}
                                    variant="outlined"
                                    placeholder="Select"
                                    onBlur={handleBlur}
                                    error={touched.languagesSpoken && Boolean(errors.languagesSpoken)}
                                    helperText={touched.languagesSpoken && errors.languagesSpoken}
                                    sx={{
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Component4>


                        </AddContainer>

                    </Form>
                )}
            </Formik>
        </>
    );
};

export default PersonalInfoStep;

